import { EDITORIAL_NOTES } from "../../../mocks/newsData";

const STATS = [
  { num: "24h", label: "全天候盯热点" },
  { num: "1200+", label: "日均聚合快讯" },
  { num: "3 源", label: "交叉核验信源" },
  { num: "100%", label: "信息可溯源" },
];

const PRAISE = [
  { text: "信息更新够快，一个话题不用来回翻好几个平台，在这里能看完整。", name: "热心读者 · 赵先生", role: "每日通勤读者" },
  { text: "喜欢它的“追踪”逻辑，快讯之后有更新、有更正，心里踏实。", name: "资讯爱好者 · 小敏", role: "关注财经动态" },
  { text: "作为内容从业者，最认可的是尊重版权、标注来源这一点。", name: "自媒体作者 · 阿凯", role: "行业观察者" },
];

export default function AboutSection() {
  return (
    <section className="mx-auto max-w-[1440px] px-4 py-10 md:px-6 md:py-14" id="about">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        {/* 编辑部速览 */}
        <div className="lg:col-span-5">
          <div className="flex items-center gap-2">
            <span className="h-5 w-1 rounded-full bg-primary-500" aria-hidden="true" />
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">关于编辑部</h2>
          </div>
          <p className="mt-4 font-heading text-lg font-bold leading-relaxed text-foreground-950">
            实时爆料，一个专注“更快、更准、更完整”的今日热点追踪平台。
          </p>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            在这个信息爆炸的年代，最大的焦虑不是“没新闻”，而是“假新闻太多、真进展太散”。实时爆料想解决的，正是这件事——我们把分散在全网的实时进展聚合成一条清晰的时间线，用滚动更新的方式，把每件大事从“刚刚发生”一路讲到“尘埃落定”。
          </p>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            我们相信，及时的爆料不该靠博眼球的话术堆砌，而要靠扎实的核实与持续的经营。这里不做标题党、不贩卖焦虑，只用最直接的方式，把你真正关心的动态第一时间送达。
          </p>
          <a
            href="#contact"
            className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            加入我们的线索网络
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        {/* 数据与原则 */}
        <div className="lg:col-span-7">
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-lg bg-accent-100/70 p-4 text-center">
                <p className="font-label text-2xl font-bold text-accent-800 md:text-3xl">{s.num}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {EDITORIAL_NOTES.map((note) => (
              <div
                key={note.title}
                className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100/70 p-4"
              >
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-secondary-100 text-xl text-secondary-700">
                  <i className={note.icon} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950">{note.title}</h3>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{note.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 用户口碑 */}
      <div className="mt-8 rounded-lg border border-background-200 bg-background-100/50 p-5 md:p-6">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-chat-heart-line text-primary-500" aria-hidden="true" />
          读者怎么说
        </h3>
        <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
          {PRAISE.map((p) => (
            <figure key={p.name} className="flex flex-col rounded-lg bg-background-50 p-4">
              <i className="ri-double-quotes-l text-2xl text-primary-300" aria-hidden="true" />
              <blockquote className="mt-1 flex-1 text-sm leading-6 text-foreground-700">{p.text}</blockquote>
              <figcaption className="mt-3 border-t border-background-200 pt-3">
                <p className="text-sm font-medium text-foreground-900">{p.name}</p>
                <p className="text-xs text-foreground-500">{p.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}